import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 1,
  class: "uploaded-files"
}
const _hoisted_4 = { class: "file" }
const _hoisted_5 = { class: "filename" }
const _hoisted_6 = { class: "column-left" }
const _hoisted_7 = { class: "column-right" }

import { ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import UppyUploaderWrapper from "@/components/shared/UppyUploaderWrapper.vue";
import { DocumentEntityTypes } from "@/models/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'InlineUppyUploader',
  props: {
  applicationId: { type: Number },
  applicant: { type: Object },
  documentTypeId: { type: Number },
  height: { type: Number, default: 400 },
  name: { type: String },
  stipulationId: { type: Number, required: false },
  uploadSuccess: { type: Boolean, required: false },
  uploadComplete: { type: Boolean, required: false },
},
  emits: ["getDocuments", "uploadSuccess", "errorMessageUpdated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const store = useStore();

let uploadedFiles = reactive([] as any[]);

const fileUploadComplete = ref<boolean>(false);
const errorMessageText = ref<string>("");

const uppyId = computed<string>(() => `uppy_${props?.name}`);
const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);
const contactUs = computed(() => store.getters["contactUs"]);

const metadata = computed(() => store.getters["checklistModule/getUploadMetadata"](props.stipulationId, oidcUser?.value?.sub));

function setErrorMessage(event: any) {
  errorMessageText.value = event.errorMessage;
}

function handleUploadComplete(event: any) {
  const file = event?.successful[0];
  if (file) {
    emit("uploadSuccess", { result: true });
    uploadedFiles = event.successful;
    fileUploadComplete.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(UppyUploaderWrapper, {
    uppyId: uppyId.value,
    metadata: metadata.value,
    height: __props.height,
    "document-type-id": __props.documentTypeId,
    "upload-success": __props.uploadSuccess,
    "upload-complete": __props.uploadComplete,
    "contact-us": contactUs.value,
    onErrorMessageUpdate: setErrorMessage,
    onUploadComplete: handleUploadComplete
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(uploadedFiles)?.length <= 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "drag-drop-area",
              id: uppyId.value
            }, null, 8, _hoisted_2))
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadedFiles), (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "uploaded-file",
                  key: index
                }, [
                  _createTextVNode(_toDisplayString(file) + " ", 1),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_font_awesome_icon, {
                            class: "icon complete",
                            icon: ['fas', 'circle-check']
                          })
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", null, _toDisplayString(file?.name), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ], 512)), [
              [_vShow, _unref(uploadedFiles) && _unref(uploadedFiles)?.length > 0]
            ])
      ])
    ]),
    _: 1
  }, 8, ["uppyId", "metadata", "height", "document-type-id", "upload-success", "upload-complete", "contact-us"]))
}
}

})